import { Box, styled } from '@mui/material';

const ToggleRow = styled(Box)`
  display: flex;
  gap: 16px;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export default ToggleRow;